import React, { useMemo } from 'react';
import { Form, Row } from 'react-bootstrap';
import Accordion from 'components/Accordion';
import useClassicOptions from 'hooks/Flux/Automatic/Classic/useClassicOptions';
import DatePicker from 'components/DatePicker';
import Model from 'components/Flux/Automatic/ControlPanel/PastSimulations/New/Form/Model';
import sortedDatesAsIntervals from 'helper/Shared/sortedDatesAsIntervals';
import { cssVar } from 'constants/theme';
import ForecastDateSelector from './ForecastDateSelector';

const labelStyle = { fontWeight: 400, color: cssVar('text-secondary') };

export default function ClassicControlPanel() {
  const {
    acomphDate,
    acomphDates,
    forecastDateLabel,
    forecastDates,
    model,
    models,
    setForecastDate,
    setModel,
    setAcomphDate,
  } = useClassicOptions();

  const availableIntervals = useMemo(
    () => sortedDatesAsIntervals(acomphDates),
    [acomphDates],
  );

  return (
    <Form>
      <Row className="mb-3">
        <Form.Label column className="text-start" style={labelStyle}>Data da ACOMPH</Form.Label>
      </Row>
      <div className="mb-3 d-flex">
        <DatePicker
          placeholderText="Selecione uma data"
          onChange={(date: Date | null) => setAcomphDate(date || new Date())}
          containerClass="w-100"
          wrapperClassName="w-100"
          className="form-control"
          selected={acomphDate}
          includeDateIntervals={availableIntervals}
        />
      </div>
      <Accordion key="flux-automatic-classic-forecast-date">
        <ForecastDateSelector onChange={setForecastDate} forecastDates={forecastDates} />
        <Model key={forecastDateLabel} value={model} onChange={setModel} models={models} />
      </Accordion>
    </Form>
  );
}
